import { render, staticRenderFns } from "./page-not-found.view.vue?vue&type=template&id=109bb807&scoped=true&lang=pug"
import script from "./page-not-found.view.vue?vue&type=script&lang=ts"
export * from "./page-not-found.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109bb807",
  null
  
)

export default component.exports